/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 6/14/15.
 */
'use strict';
angular.module('prism-ui.components').directive('dateTimePicker', function (moment) {

		return {
			restrict: 'E',
			controller: function(){},
			templateUrl: 'components/visual/dateTime/datetime-template.html',
			require: ['ngModel', 'dateTimePicker'],
			scope: {componentDisabled: '=ngDisabled', fieldSetSize: '=', calBtnId: '@'},
			bindToController: {componentDisabled: '=ngDisabled', fieldSetSize: '=', calBtnId: '@'},
			controllerAs: 'dateTimePickerCtrl',
			link: function (scope, element, attrs, ctrls) {
				var ngModelCtrl = ctrls[0];
				var dateTimePickerCtrl = ctrls[1];
				dateTimePickerCtrl.calBtnId = dateTimePickerCtrl.calBtnId || attrs.id;
				ngModelCtrl.$render = function() {
					dateTimePickerCtrl.datePart = ngModelCtrl.$viewValue.datePart;
					dateTimePickerCtrl.timePart = ngModelCtrl.$viewValue.timePart;
				};

				ngModelCtrl.$formatters.push(function (modelValue) {
					var datePart = modelValue, timePart;
					if (!datePart) {
						datePart = undefined;
						timePart = new Date(2000,0,1,0,0,0,0);
					}
					else if (!(datePart instanceof Date)) {
						datePart = moment(modelValue).toDate();
					}

					return {
						datePart: datePart,
						timePart: timePart || datePart
					};
				});

				ngModelCtrl.$parsers.push(function(viewValue) {
					var newDate = viewValue.datePart;
					if (newDate) {
						newDate.setHours(viewValue.timePart.getHours());
						newDate.setMinutes(viewValue.timePart.getMinutes());
					}
					return newDate;
				});

				dateTimePickerCtrl.dateChanged = function() {
					if(!dateTimePickerCtrl.datePart) {
						dateTimePickerCtrl.timePart = new Date(2000,0,1,0,0,0,0);
					}
					ngModelCtrl.$setViewValue({datePart: dateTimePickerCtrl.datePart, timePart: dateTimePickerCtrl.timePart});
				};
			}
		};
	});
